import i18n from '../../../../i18n';
import React from 'react';

const isProduction = process.env.REACT_APP_ENV === 'production';

const allMenus = [
  {
    label: () => i18n.t('sidebar.dashboard', 'Dashboard'),
    key: 'dashboard',
    icon: 'solar:widget-linear',
  },
  {
    label: () => i18n.t('sidebar.orders', 'Orders'),
    key: 'orders',
    icon: 'solar:file-text-linear',
    children: [
      {
        key: 'order-summary',
        label: () => i18n.t('sidebar.orderSummary', 'Order Summary'),
        icon: 'solar:chart-square-linear',
      },
      {
        key: 'all-orders',
        label: () => i18n.t('sidebar.allOrders', 'All Orders'),
        icon: 'solar:bill-list-linear',
      },
    ],
  },
  {
    label: () => i18n.t('sidebar.productManagement', 'Product Management'),
    key: 'product-management',
    icon: 'solar:box-minimalistic-linear',
    children: [
      {
        key: 'products',
        label: () => i18n.t('sidebar.products', 'Products'),
        icon: 'solar:box-linear',
      },
      {
        key: 'inventory',
        label: () => i18n.t('sidebar.inventory', 'Inventory'),
        icon: 'material-symbols:shelves-outline',
      },
      {
        key: 'categories',
        label: () => i18n.t('sidebar.categories', 'Categories'),
        icon: 'solar:folder-open-linear',
      },
      {
        key: 'catalogs',
        label: () => i18n.t('sidebar.catalog', 'Catalog'),
        icon: 'solar:database-linear',
      },
      {
        key: 'brands',
        label: () => i18n.t('sidebar.brands', 'Brands'),
        icon: 'solar:tag-linear',
      },
    ],
  },
  {
    label: () => i18n.t('sidebar.userManagement', 'User Management'),
    key: 'user-access',
    icon: 'solar:folder-with-files-linear',
    children: [
      {
        key: 'roles',
        label: () => i18n.t('sidebar.Roles', 'Roles'),
        icon: 'solar:shield-user-linear',
      },
      {
        key: 'user-management',
        label: () => i18n.t('sidebar.users', 'Users'),
        icon: 'solar:users-group-rounded-linear',
      },
    ],
  },
  {
    label: () => i18n.t('sidebar.reports', 'Reports'),
    key: 'reports',
    icon: 'solar:document-linear',
    children: [
      {
        key: 'order-reports',
        label: () => i18n.t('sidebar.orderReports', 'Order Reports'),
        icon: 'solar:document-text-linear',
      },
      {
        key: 'sales-reports',
        label: () => i18n.t('sidebar.salesReports', 'Sales Reports'),
        icon: 'solar:chart-2-linear',
      },
      {
        key: 'returns-reports',
        label: () => i18n.t('sidebar.returnsReports', 'Returns Reports'),
        icon: 'solar:restart-linear',
      },
      {
        key: 'order-analysis',
        label: () => i18n.t('sidebar.orderAnalysis', 'Order Analysis'),
        icon: 'solar:graph-up-linear',
      },
      {
        key: 'sku-perfomance',
        label: () => i18n.t('sidebar.skuPerformance', 'SKU Performance'),
        icon: 'solar:star-linear',
      },
      {
        key: 'kpi-overview',
        label: () => i18n.t('sidebar.kpiOverview', 'KPI Overview'),
        icon: 'solar:spedometer-middle-linear',
      },
      {
        key: 'ads-performance',
        label: () => i18n.t('sidebar.adsPerformance', 'Ads Performance'),
        icon: 'solar:chart-square-linear',
      },
    ],
  },
  {
    label: () => i18n.t('sidebar.importedData', 'Imported Data'),
    key: 'imported-data',
    icon: 'solar:download-linear',
    children: [
      {
        key: 'manual-upload',
        label: () => i18n.t('sidebar.uploadFile', 'Upload File'),
        icon: 'solar:cloud-upload-linear',
      },
      {
        key: 'imported-reports',
        label: () => i18n.t('sidebar.importedReports', 'Imported Reports'),
        icon: 'solar:file-check-linear',
      },
    ],
  },
  {
    label: () => i18n.t('sidebar.exports', 'Exports'),
    key: 'exports',
    icon: 'solar:upload-linear',
  },
  {
    label: () => i18n.t('sidebar.appManagement', 'App Management'),
    key: 'app-management',
    icon: 'solar:widget-2-linear',
  },
  {
    label: () => (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        {i18n.t('sidebar.subscription', 'Subscription')}
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: '#b45309',
            background: '#fff0e4',
            borderRadius: 999,
            padding: '1px 8px',
          }}
        >
          {i18n.t('sidebar.newBadge', 'New')}
        </span>
      </span>
    ),
    key: 'subscription',
    icon: 'solar:card-linear',
  },
  // {
  //   label: () => i18n.t('sidebar.addCredentials', 'Add Credentials'),
  //   key: 'callback-sp',
  //   icon: 'solar:key-linear',
  // },
  {
    label: () => i18n.t('sidebar.applicationLogs', 'Application Logs'),
    key: 'applicatiion-logs',
    icon: 'lsicon:list-outline',
    children: [
      {
        key: 'applicatiion-logs/central-log',
        label: () => i18n.t('sidebar.centralLog', 'Central Log'),
        icon: 'solar:server-linear',
      },
      {
        key: 'applicatiion-logs/system-error-log',
        label: () => i18n.t('sidebar.systemErrorLog', 'System Error Log'),
        icon: 'solar:danger-triangle-linear',
      },
    ],
  },
];

const productionHiddenItems = [
  'order-summary',
  'order-analysis',
  'sku-perfomance',
  'kpi-overview',
  'applicatiion-logs',
];

export const UserMenus = allMenus
  .filter((menu) => {
    if (isProduction && productionHiddenItems.includes(menu.key)) {
      return false;
    }
    return true;
  })
  .map((menu) => {
    if (menu.children && isProduction) {
      const filteredChildren = menu.children.filter(
        (child) => !productionHiddenItems.includes(child.key)
      );
      return { ...menu, children: filteredChildren };
    }
    return menu;
  })
  .filter((menu) => !menu.children?.length || menu.children.length > 0);
